import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import ReviewsContent from 'app/pageContents/ReviewsContent';
import { configureSignUpBonusPageHead } from 'app/utils/configurePageHead';
import { getReviewPageProps } from 'app/selectors/productSelector';
import {
  getProducts,
  getProductCategories,
  getPrismic,
} from 'app/dispatcher/productDispatcher';
import { RootState } from 'app/reducer';

import dispatchWithPromise from 'app/utils/withPromise';

const overrideWrapperStyles = {
  justifyContent: 'stretch',
  flexDirection: 'column',
};

const SignUpBonusPage = () => {
  const reviewHeaderProps = useSelector(getReviewPageProps, shallowEqual);
  const products = useSelector((state: RootState) => state.product.products);
  return (
    <Page pageContentStyle={overrideWrapperStyles}>
      <PageHead
        {...configureSignUpBonusPageHead({ ...reviewHeaderProps, products })}
      />
      <ReviewsContent type="sign-up-bonus" />
    </Page>
  );
};

SignUpBonusPage.getInitialProps = async ({ store, query }) => {
  const { dispatch } = store;

  dispatch(getPrismic('sign-up-bonus', { isSignUpBonus: true }));

  await Promise.all([
    dispatchWithPromise(dispatch, getProductCategories, {
      sign_up_bonus: true,
    }),
    dispatchWithPromise(dispatch, getProducts, {
      ...query,
      isSignUpBonus: true,
    }),
  ]);
  return {};
};

export default SignUpBonusPage;
